import { render, staticRenderFns } from "./PointRecord.vue?vue&type=template&id=cae95ed2&scoped=true&"
import script from "./PointRecord.vue?vue&type=script&lang=ts&"
export * from "./PointRecord.vue?vue&type=script&lang=ts&"
import style0 from "./PointRecord.vue?vue&type=style&index=0&id=cae95ed2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae95ed2",
  null
  
)

export default component.exports